import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ProfileApiUser = {
  id: number;
  email: string;
  full_name: string;
  name?: string;
  is_active?: boolean;
  organization_id?: number;
  manager_id?: number | null;
  country_code?: string | number | null;
  phone_number?: string | null;
};

export type ProfileApiData = {
  user: ProfileApiUser;
  company?: {
    id: number;
    name: string;
    type: string;
    channel_code: string | null;
    is_active: boolean;
  } | null;
  roles?: Array<{ id: number; name: string; display_name: string }>;
};

export type ProfileState = {
  data: ProfileApiData | null;
  isLoading: boolean;
  isUpdating: boolean;
  error: string | null;
};

const initialState: ProfileState = {
  data: null,
  isLoading: false,
  isUpdating: false,
  error: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<ProfileApiData>) {
      state.data = action.payload;
      state.isLoading = false;
      state.isUpdating = false;
      state.error = null;
    },
    setProfileLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
      if (action.payload) {
        state.data = null;
        state.error = null;
      }
    },
    setProfileUpdating(state, action: PayloadAction<boolean>) {
      state.isUpdating = action.payload;
      if (action.payload) state.error = null;
    },
    setProfileError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.isLoading = false;
      state.isUpdating = false;
    },
    clearProfile: () => initialState,
  },
});

export const { setProfile, setProfileLoading, setProfileUpdating, setProfileError, clearProfile } =
  profileSlice.actions;

export default profileSlice.reducer;
